import {Navigate, Outlet} from 'react-router'
import styled from 'styled-components'

import {LoadingPage} from '@pleo-io/telescope'

import {useCompanyFeatureEntitlement} from '~/entitlement/use-feature-entitlement'
import {reportError} from '~/error/report'
import {EmptyStatesBudgets} from '~/feature-adoption/empty-states/empty-states-budgets'
import {useFlags} from '~/flags'
import {Page as GenericPage} from '~/generic-ui/page'

import {bff} from '../bff'

export function BudgetsAuthAndRoutes() {
    const {tagBudgets: hasTagBudgetsFlag} = useFlags()

    const {data: hasAccessToBudgets, isLoading} = bff.tagBudgetsAuth.getHasAccessToBudgets.useQuery(
        undefined,
        {
            onError(error) {
                reportError(error)
            },
        },
    )

    const {isEntitled: hasBudgetsEntitlements, isLoading: isLoadingEntitlements} =
        useCompanyFeatureEntitlement('BUDGETS')

    // Show loading indicator until we have fetched permissions
    const isLoadingData = isLoading || isLoadingEntitlements || hasTagBudgetsFlag === undefined
    if (isLoadingData) {
        return <LoadingPage />
    }

    const isMissingAccess = Boolean(hasAccessToBudgets) === false
    if (isMissingAccess) {
        return <Navigate to="/" />
    }

    const shouldShowPlanUpgrade = !hasTagBudgetsFlag && !hasBudgetsEntitlements
    if (shouldShowPlanUpgrade) {
        return (
            <GenericPage layout="wide" showNav>
                <EmptyStatesBudgetsWrapper>
                    <EmptyStatesBudgets />
                </EmptyStatesBudgetsWrapper>
            </GenericPage>
        )
    }

    return <Outlet />
}

export const EmptyStatesBudgetsWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    min-height: calc(100vh - 76px);
`

export default BudgetsAuthAndRoutes
